/* eslint-disable max-len */

import * as React from 'react';

const Shift: React.FC = () => (
    <svg className="icon" viewBox="0 0 100 100">
        <path
            d="M68.85,84.96H31.34V52.08h-15.6l35.19-37.04l33.34,37.04H68.85V84.96z M35.98,80.32h28.24V47.45h9.64L50.83,21.87
    l-24.3,25.58h9.44V80.32z"
        />
    </svg>
);

export default Shift;
